import React from 'react';
import LazyLoadedImage from './lazy-loaded-image';
import PreloadedImage from './preloaded-image';

const Image = props => {
  const {
    lazyLoad,
    ...rest
  } = props;
  return lazyLoad ? /*#__PURE__*/React.createElement(LazyLoadedImage, rest) : /*#__PURE__*/React.createElement(PreloadedImage, rest);
};

export default Image;